import React from 'react';
import { propTypes } from '../../util/types';
import { ensureUser, userDisplayNameAsString } from '../../util/data';
import { richText } from '../../util/richText';
import SectionHeading from '../../containers/ProjectListingPage/SectionHeading';
import SectionDescriptionMaybe from '../../containers/ProjectListingPage/SectionDescriptionMaybe';

import css from './ProjectListingModalContent.css';

const MIN_LENGTH_FOR_LONG_WORDS_IN_TITLE = 16;

// Job posting content for a modal: the same heading and description sections as
// ProjectListingPage, without the apply buttons.
const ProjectListingModalContent = props => {
  const { listing } = props;
  const { title = '', publicData = {} } = listing.attributes;
  const author = ensureUser(listing.author);

  const richTitle = (
    <span>
      {richText(title, {
        longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS_IN_TITLE,
        longWordClass: css.longWord,
      })}
    </span>
  );

  return (
    <div className={css.root}>
      <SectionHeading
        richTitle={richTitle}
        hostLink={userDisplayNameAsString(author, '')}
        user={author}
        publicData={publicData}
        showContactUser={false}
        hasExistingProposal={false}
        iconsWrapperClassName={css.sectionIconWrapper}
      />
      <SectionDescriptionMaybe
        publicData={publicData}
        showContactUser={false}
        hasExistingProposal={false}
      />
    </div>
  );
};

ProjectListingModalContent.propTypes = {
  listing: propTypes.listing.isRequired,
};

export default ProjectListingModalContent;
